const INTERNAL_ORIGIN = 'https://tacit.invalid';
const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;
const MAX_RETURN_PATH_LENGTH = 2_048;

export function sanitizeInternalReturnPath(
  value: string | null | undefined,
): string {
  if (
    !value
    || value.length > MAX_RETURN_PATH_LENGTH
    || value !== value.trim()
    || !value.startsWith('/')
    || value.startsWith('//')
    || value.includes('\\')
  ) {
    return '/';
  }

  let decoded: string;
  try {
    decoded = decodeURIComponent(value);
  } catch {
    return '/';
  }

  if (
    CONTROL_CHARACTERS.test(decoded)
    || decoded.startsWith('//')
    || decoded.startsWith('/\\')
    || decoded.includes('\\')
  ) {
    return '/';
  }

  try {
    const parsed = new URL(value, INTERNAL_ORIGIN);
    if (parsed.origin !== INTERNAL_ORIGIN) return '/';

    const decodedPathname = decodeURIComponent(parsed.pathname);
    if (
      !decodedPathname.startsWith('/')
      || decodedPathname.startsWith('//')
      || decodedPathname.includes('\\')
      || CONTROL_CHARACTERS.test(decodedPathname)
    ) {
      return '/';
    }

    const normalizedPathname = decodedPathname.toLowerCase();
    if (
      normalizedPathname === '/login'
      || normalizedPathname.startsWith('/login/')
    ) {
      return '/';
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return '/';
  }
}
